import { render, staticRenderFns } from "./ExploreCardV2.vue?vue&type=template&id=b2960d0a&scoped=true"
import script from "./ExploreCardV2.vue?vue&type=script&lang=js"
export * from "./ExploreCardV2.vue?vue&type=script&lang=js"
import style0 from "./ExploreCardV2.vue?vue&type=style&index=0&id=b2960d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2960d0a",
  null
  
)

export default component.exports